// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15X78","placeholdersHeader":"styles_placeholdersHeader__2zWAA","editorStyle":"styles_editorStyle__3ixEO","placeholdersBox":"styles_placeholdersBox__3b0XY"};